import { useContext } from 'react';

import {
    PrescriberOrderContext,
    type PrescriberOrderCtx,
} from '../contexts/prescriber-order-context';

export const usePrescriberOrder = (): PrescriberOrderCtx => {
    const ctx = useContext(PrescriberOrderContext);

    if (ctx === null) {
        throw new Error(
            'usePrescriberOrder must be called within a PrescriberOrderProvider'
        );
    }

    return ctx;
};
